export interface User {
  id: number;
  firstName: string;
  lastName: string;
  isAdmin: boolean;
  isDemo: boolean;
  cguAcceptedAt: Date;
  UserSpecificRights: any; // to delete
}

export const isAdmin = (user: User|undefined): boolean => !!user?.isAdmin;
export const isDemo = (user: User|undefined): boolean => !!user?.isDemo;
export const hasAcceptedCgu = (user: User|undefined): boolean => !!user?.cguAcceptedAt;
export const userCompaniesIds = (user: User|undefined, right?: string): number[] => [
  ...new Set(
    user?.UserSpecificRights
      ?.filter((ur) => !right || ur.Rights.code === right)
      ?.map((ur) => ur.companyId) || [],
  ),
].map(Number);
